import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../_models/material';

@Pipe({
  name: 'searchMaterialsPipe'
})

export class SearchMaterialsPipe implements PipeTransform {
  transform(data: Material[], searchTerm: string) {
    let st:string = searchTerm.toLowerCase();
    return data.filter(material => material.name.toLowerCase().indexOf(st) !== -1 ||
      (''+material.id).toLowerCase().indexOf(st) !== -1);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/searchMaterials.pipe.ts